import { FC } from 'react';

import useTranslations from 'modules/I18n/hooks/useTranslations';
import { DialogConfirm, MODAL_WIDTH_SMALLEST } from 'modules/Modals';
import { Text } from 'modules/Ui';

import { dialogVerifactuSign } from './messages';

const VerifactuDialogSign: FC = () => {
  const {
    t,
    formatHelpers: { bold },
  } = useTranslations();
  return (
    <DialogConfirm
      dialogWidth={MODAL_WIDTH_SMALLEST}
      title={t(dialogVerifactuSign.title)}
      onConfirm={() => console.log('Firmar Verifactu...')}
    >
      <>
        <Text marginBottom="16px" lineHeight={22}>
          {t(dialogVerifactuSign.text01, { b: bold() })}
        </Text>
        <Text lineHeight={22}>
          {t(dialogVerifactuSign.text02, { b: bold() })}
        </Text>
      </>
    </DialogConfirm>
  );
};

export default VerifactuDialogSign;
